export const VISUAL_PROFILE_RELATIONSHIP_TYPE = "visual-profile-relationship";
export function isVisualProfileRelationship(what) {
    return what.type.includes(VISUAL_PROFILE_RELATIONSHIP_TYPE);
}
//# sourceMappingURL=visual-profile-relationship.js.map